import React, { Component } from 'react';
 import "./page404.css"
import  AuthService  from "../api/authentication.js";

const Auth = new AuthService();
class Londing extends Component {

    constructor(props){
        super(props)
        this.state ={
             noerorrpage :  true
        }
    }
    

    
  componentDidMount(){
    this.props.noerorrpage(this.state.noerorrpage)
  }


  
  render() {
      const stylelogo ={
        width:"10px"
      }
    return (
      <div className="Loaing-page-fullbody">
       
                {/* <p className="para-page-error">Trying to login</p> */}
                <br/>
                
                <div className="hero is-bold ">
                    <div className="level-item" style={{textAlign:"center"}}>
                        <a className="button is-loading is-large is-light">Loading</a>
                    </div>
                    <div className="level-item" style={{textAlign:"center"}}>
                        <span>Loading.....</span>
                    </div>
                </div>
            
       
    
      </div>
    );
  }
}

export default Londing ;







// WEBPACK FOOTER //
// ./src/component/page/loading.js